document.addEventListener('DOMContentLoaded', function() {

    initSubmenuToggles();

    const navbarToggle = document.getElementById('navbar-toggle');
    const mainNavigation = document.querySelector('.custom-nav__drawer');
    const closeToggle = document.querySelector('.custom-nav__close-toggle');

    // Open mobile nav
    if (navbarToggle && mainNavigation) {
        navbarToggle.addEventListener('click', function() {        	
            const isExpanded = this.getAttribute('aria-expanded') === 'true';
            this.setAttribute('aria-expanded', String(!isExpanded));
            mainNavigation.classList.toggle('expanded');
        });
    }

    // Close mobile nav
    if (closeToggle && mainNavigation) {
        closeToggle.addEventListener('click', function() {
            mainNavigation.classList.remove('expanded');
            navbarToggle.setAttribute('aria-expanded', 'false');
        });
    }


    // Disable core/navigation hover behavior on mobile/tablet
    function isMobile() {
        return window.innerWidth < 992;
    }    
    const submenuItems = document.querySelectorAll('.wp-block-navigation-submenu.open-on-hover-click');

    submenuItems.forEach(item => {
        item.addEventListener('mouseenter', function(e) {
            if (isMobile()) {
                e.stopImmediatePropagation();
            }
        }, true);

        item.addEventListener('mouseleave', function(e) {
            if (isMobile()) {
                e.stopImmediatePropagation();
            }
        }, true);
    });


    // Expand inner dropdown sub-menus
    function initSubmenuToggles() {    
    
    const mobileArrows = document.querySelectorAll('.mobile-arrow');

    mobileArrows.forEach(function (arrow) {
        arrow.addEventListener('click', function () {
            const subMenu = this.nextElementSibling;

            if (!subMenu || !subMenu.classList.contains('sub-menu')) return;

            const isExpanded = this.getAttribute('aria-expanded') === 'true';

            this.setAttribute('aria-expanded', String(!isExpanded));
            this.classList.toggle('selected');

            subMenu.setAttribute('aria-expanded', String(!isExpanded));
            subMenu.classList.toggle('expanded');

            // Vanilla JS slide toggle via max-height
            if (subMenu.style.maxHeight) {
                subMenu.style.maxHeight = null;
            } else {
                subMenu.style.maxHeight = subMenu.scrollHeight + 'px';
            }
        });
    });    

    }
    

});